import { lazy } from "react";
import { withSuspense } from "./routeHelpers";

const NewStudents = lazy(
  () =>
    import(/* webpackChunkName: "newStudents" */ "../NewStudents/NewStudents")
);

export default [
  {
    path: "/new_students",
    element: withSuspense(NewStudents),
  },
];
